module.exports = __webpack_public_path__ + "static/10-0cb33acdccc696ca25f242e9616d2f17.jpg";